// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { valueAddedServiceSidebarStyles } from "@awc/App/Widgets/ValueAddedServices/ValueAddedServicesSideBar";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

valueAddedServiceSidebarStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 16px;
        margin: 28px 0;
    `,
};

valueAddedServiceSidebarStyles.title = {
    size: 18,
    lineHeight: "24px",
    css: css`
        text-align: center;
        word-break: keep-all;
    `,
};

valueAddedServiceSidebarStyles.image = {
    css: css`
        height: max-content;
    `,
};

valueAddedServiceSidebarStyles.actionClickable = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: calc(50% - 8px);
        padding: 8px;
        border-radius: 16px;
        &:hover {
            ${({ selectedColor }: any) =>
                selectedColor &&
                css`
                    box-shadow: 0 0 2px 1px ${selectedColor};
                `}
            ${TypographyStyle} {
                text-decoration: underline;
            }
        }
        ${TypographyStyle} {
            ${({ selectedColor }: any) =>
                selectedColor &&
                css`
                    color: ${selectedColor};
                `}
        }
    `,
};
